import * as Api from '@ViewModels';

/**
 * The statuses the report offers, and the order they appear in. `Draft` is the one `BlogStatus` value
 * deliberately left out — a draft has never been scheduled, so it has nothing to report on.
 */
export const allBlogStatusFilterValues = [
	Api.BlogStatus.Pending,
	Api.BlogStatus.Queued,
	Api.BlogStatus.Completed,
	Api.BlogStatus.Cancelled,
	Api.BlogStatus.Failed,
	Api.BlogStatus.Rejected,
];

const blogStatusFilterLabelMap: Partial<Record<Api.BlogStatus, string>> = {
	[Api.BlogStatus.Cancelled]: 'Cancelled',
	[Api.BlogStatus.Completed]: 'Published',
	[Api.BlogStatus.Failed]: 'Failed',
	[Api.BlogStatus.Pending]: 'Pending Approval',
	[Api.BlogStatus.Queued]: 'Scheduled',
	[Api.BlogStatus.Rejected]: 'Rejected',
};

export const blogStatusLabel = (status: Api.BlogStatus) => blogStatusFilterLabelMap[status] ?? status;
